import { Heading } from 'native-base';
import React, { ReactNode } from 'react';

import { tID } from 'app/services/TestHelper';

export type AuthTitleProps = {
  children?: ReactNode;
};

export default function AuthTitle({ children }: AuthTitleProps) {
  return (
    <Heading fontSize="xl" mb="3" testID={tID('AuthTitle')} textAlign="center">
      {children}
    </Heading>
  );
}
